<template>
  <div id="app">
    <div style="margin: 0 auto; text-align: left; padding: 0px 16px">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created() {},
  mounted() {
    document.title = "FAQ of AICOOL";
  },
  methods: {
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #f5f5f5;
  height: 100vh;
}
* {
  margin: 0;
  padding: 0;
}
</style>
